[
  {
    "id": "chapter:2a",
    "q": "Kansas law requires that all occupants use safety restraints in passenger vehicles.",
    "answer": {
      "text": "True",
      "section": 2,
      "topic": "Seatbelts",
      "page": 16
    },
    "otherChoices": ["False"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:2b",
    "q": "You must stop when meeting or overtaking a bus that is stopped to pick up or let off children.",
    "answer": {
      "text": "True",
      "section": 2,
      "topic": "School Buses",
      "page": 18
    },
    "otherChoices": ["False"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:7d",
    "q": "When is it safe to pass another vehicle?",
    "answer": {
      "text": "Whenever signs and/or roadway markings permit passing other vehicles",
      "section": 2,
      "topic": "Passing",
      "page": 17
    },
    "otherChoices": [
      "When driving through an intersection and there are no oncoming vehicles",
      "When entering a curve and there are no oncoming vehicles"
    ],
    "generated": null,
    "batch": "review-20260430",
    "version": 3,
    "updatedAt": "2026-04-30",
    "status": "verified"
  },
  {
    "id": "authored:s2-signal-distance",
    "q": "All turn and lane-change signals must be given at least:",
    "answer": {
      "text": "100 feet before making the actual move or turn",
      "section": 2,
      "topic": "Signaling for Stops and Turns",
      "page": 17
    },
    "otherChoices": [
      "200 feet before making the actual move or turn",
      "500 feet before making the actual move or turn"
    ],
    "generated": null,
    "batch": "review-20260604",
    "version": 1,
    "updatedAt": "2026-06-04",
    "status": "verified"
  },
  {
    "id": "authored:s2-u-turn-visibility",
    "q": "Do not make a \"U\" turn on a curve, near the top of a hill, or anywhere you cannot be seen by other drivers for at least:",
    "answer": {
      "text": "500 feet",
      "section": 2,
      "topic": "\"U\" Turns (K.S.A. 8-1546)",
      "page": 17
    },
    "otherChoices": ["100 feet", "200 feet"],
    "generated": null,
    "batch": "expansion-r1-20260729",
    "version": 1,
    "updatedAt": "2026-07-29",
    "status": "verified"
  },
  {
    "id": "authored:s2-electronic-device-law",
    "q": "Kansas law prohibits the use of any electronic device while driving:",
    "answer": {
      "text": "To \"write, send, or read\" a written communication",
      "section": 2,
      "topic": "Cell Phones (K.S.A 8-1598)",
      "page": 19
    },
    "otherChoices": ["To talk on a cell phone or dial a phone number", "To use GPS devices or check weather reports"],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 2,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s2-basic-speed-law",
    "q": "Under Kansas' basic speed law, whether a speed is reasonable and prudent depends on:",
    "answer": {
      "text": "Road, weather, and your vehicle condition, as well as your own physical condition",
      "section": 2,
      "topic": "Basic Speed Law (K.S.A. 8-1557)",
      "page": 16
    },
    "otherChoices": ["How many times you have driven the roadway before", "The time you can save by driving faster"],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 3,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s2-no-passing-zone-pennant",
    "q": "The only pennant-shaped warning sign is:",
    "answer": {
      "text": "The \"No Passing Zone\" sign",
      "section": 2,
      "topic": "Passing (K.S.A. 8-1516, 8-1518, 8-1520)",
      "page": 17
    },
    "otherChoices": ["The Yield sign", "The Do Not Pass sign"],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 2,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s2-school-zone-speed",
    "q": "Unless otherwise posted, the maximum speed limit in a properly marked school zone is:",
    "answer": {
      "text": "20 mph",
      "section": 2,
      "topic": "Speed Limits (K.S.A. 8-1558)",
      "page": 16
    },
    "otherChoices": ["30 mph", "55 mph"],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s2-passing-on-the-right",
    "q": "You may pass another vehicle on the right when:",
    "answer": {
      "text": "Driving on one-way streets and highways marked for two or more lanes of traffic moving in the same direction",
      "section": 2,
      "topic": "Passing on the Right",
      "page": 17
    },
    "otherChoices": [
      "Driving on the shoulder, whether it is paved or not",
      "Within 100 feet of crossing any intersection or railroad grade crossing"
    ],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s2-impeding-traffic",
    "q": "Even when a minimum speed is not posted:",
    "answer": {
      "text": "It is unlawful to drive so slowly as to impede or block the normal movement of traffic",
      "section": 2,
      "topic": "Minimum Speed/Impeding the Flow of Traffic (K.S.A. 8-1561)",
      "page": 16
    },
    "otherChoices": [
      "Any speed below the posted maximum is lawful",
      "Driving more than 15 mph slower than the traffic flow is safer than keeping pace"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 2,
    "updatedAt": "2026-08-03",
    "status": "verified"
  },
  {
    "id": "authored:s2-child-safety-seat-age",
    "q": "All children under the age of _____ must be restrained in a federally approved child safety seat.",
    "answer": {
      "text": "4",
      "section": 2,
      "topic": "Child Restraints (K.S.A. 8-1344)",
      "page": 16
    },
    "otherChoices": ["8", "14"],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s2-four-lane-right-turn",
    "q": "In making a right turn from a four-lane divided highway, you should:",
    "answer": {
      "text": "Enter the right lane well in advance and make a tight turn into the right lane of the cross street",
      "section": 2,
      "topic": "Turns on Multi-Lane Roads (K.S.A. 8-1545)",
      "page": 17
    },
    "otherChoices": [
      "Move near the traffic divider and turn from the inside lane",
      "Swing wide to the left before making the turn"
    ],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 1,
    "updatedAt": "2026-08-03",
    "status": "verified"
  },
  {
    "id": "authored:s2-railroad-parking-distance",
    "q": "You may not park within _____ of the nearest rail at a railroad crossing.",
    "answer": {
      "text": "50 feet",
      "section": 2,
      "topic": "Parking (K.S.A. 8-1571 8-1572)",
      "page": 19
    },
    "otherChoices": ["30 feet", "20 feet"],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  }
]
